export const GEOJSON_URL =
  "https://raw.githubusercontent.com/abhay1704/geojson/main/geocountries.geojson%20(2).gz";
